(function() {
    'use strict';

    angular
        .module('afApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider,GLOBAL_URL) {
    	$stateProvider.state('viewAll', {
            url: '/afForm',
            data: {
                pageTitle: 'Trả lại/Hủy/Thu hồi AF'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=e-stock/af/template/af',
                    controller: 'AfController',
                    controllerAs: 'afCtr'
                }
            }
        })
    }
})();